import type { VideoProgress } from '@/types/required-video';

const KEY_PREFIX = 'video-progress:';

export function emptyLocalProgress(videoKey: string): VideoProgress {
  return {
    video_key: videoKey,
    duration_secs: 0,
    seconds_watched: 0,
    last_position: 0,
    completed_at: null,
  };
}

export function loadLocalProgress(videoKey: string): VideoProgress {
  const fallback = emptyLocalProgress(videoKey);
  if (typeof window.localStorage === 'undefined') return fallback;
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + videoKey);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<VideoProgress>;
    return { ...fallback, ...parsed };
  } catch {
    return fallback;
  }
}

export function saveLocalProgress(progress: VideoProgress): void {
  if (typeof window.localStorage === 'undefined') return;
  try {
    window.localStorage.setItem(
      KEY_PREFIX + progress.video_key,
      JSON.stringify(progress)
    );
  } catch {
    /* quota exceeded or sandboxed */
  }
}
